import {Component, OnInit} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import {User} from 'shared';
import {TrailerOperationTypeService} from '../stores/trailer-operation-type.service';

@Component({
  selector: 'app-trailer-operation-types-grid',
  templateUrl: './trailer-operation-types-grid.component.html',
  styleUrls: ['./trailer-operation-types-grid.component.scss']
})
export class TrailerOperationTypesGridComponent implements OnInit {
  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;

  constructor(
    private trailerOperationTypeService: TrailerOperationTypeService,
    public user: User,
  ) {
    // Data source
    this.ds = trailerOperationTypeService.newDataSource();

    // Permissions
    this.canEdit = user.can('edit trailer operation types');
    this.canAdd = user.can('add trailer operation types');
    this.canDelete = user.can('delete trailer operation types');
  }

  ngOnInit(): void {
  }

}
